import React, { useEffect, useState } from 'react';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import { useEmbeddedDialog } from '../../utils/embedDialog';
import { subscribeNotices } from '../../utils/notices';
import './NoticeDialog.css';

function NoticeIcon({ icon, tone }) {
  const kind = icon || tone;
  if (kind === 'error') return <ErrorOutlineOutlined sx={{ fontSize: 30 }} />;
  if (kind === 'success') return <CheckCircleOutlineOutlined sx={{ fontSize: 30 }} />;
  if (kind === 'schedule') return <ScheduleOutlined sx={{ fontSize: 30 }} />;
  return <InfoOutlined sx={{ fontSize: 30 }} />;
}

export default function NoticeDialog() {
  const [notice, setNotice] = useState(null);

  useEmbeddedDialog(Boolean(notice));
  useEffect(() => subscribeNotices(setNotice), []);

  useEffect(() => {
    if (!notice) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setNotice(null);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [notice]);

  if (!notice) return null;

  const details = Array.isArray(notice.details) ? notice.details.filter((row) => row?.value) : [];

  return (
    <div
      className="mg-notice-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) setNotice(null);
      }}
    >
      <div
        className={`mg-notice${notice.tone === 'error' ? ' is-error' : ''}${notice.tone === 'success' ? ' is-success' : ''}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="mg-notice-title"
        aria-describedby="mg-notice-message"
      >
        <div className="mg-notice-icon">
          <NoticeIcon icon={notice.icon} tone={notice.tone} />
        </div>
        <h2 id="mg-notice-title">{notice.title}</h2>
        {notice.message ? <p id="mg-notice-message">{notice.message}</p> : null}
        {details.length > 0 && (
          <dl className="mg-notice-details">
            {details.map((row) => (
              <div key={row.label}>
                <dt>{row.label}</dt>
                <dd>{row.value}</dd>
              </div>
            ))}
          </dl>
        )}
        <button type="button" className="mg-notice-ok" onClick={() => setNotice(null)}>
          {notice.confirmLabel || 'OK'}
        </button>
      </div>
    </div>
  );
}
